/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import { handleBlobResponse } from '../../../../client/js/lib/download'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteTransactionFileById (id: number) {
  return rest.delete(`/api/transaction-files/${id}`)
}

export function downloadTransactionFileById (id: number) {
  return rest.get(`/api/transaction-files/${id}/file`)
    .then(handleBlobResponse)
}

export function findManyTransactionFiles (params?: Record<string, any>) {
  return rest.get(`/api/transaction-files?${stringify(params)}`)
    .then((resp) => resp.json() as HalDocument<{ files: TransactionFile[] }>)
}

export function uploadTransactionFile (file: File, tmpRef: string, transactionId: number) {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('transactionId', String(transactionId))
  fd.append('tmpRef', tmpRef)
  return rest.post('/api/transaction-files', { body: fd })
    .then((resp) => resp.json())
}
